import axios from "axios";
import {getToken, setToken} from "../utils/auth";
import {login} from "../api/login";
import {Message, MessageBox, Notification} from "element-ui";
import service from "../utils/request"; //引入axios
//下面这两个不一定需要引入，看你项目需要拦截的时候做什么操作，但是一般都需要引入store
// import store from "@/store/index"; //引入store
// import router from "@/router/index"; //引入router
// let baseUrl = document.domain

let baseUrl = document.location.origin;
// 创建axios实例

const instance = axios.create({
  baseURL: baseUrl,
  timeout: 1200000, // 请求超时时间2分钟
  // transformRequest: [
  // function(data) {
  //   console.log(data)
  //   let ret = "";
  //   for (let it in data) {
  //     ret +=
  //       encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
  //   }
  //   return ret;
  // }
  // ],
  withCredentials: true
});
instance.interceptors.request.use(
  config => {
    console.log();
    if (getToken()) {
      // let each request carry token
      // please modify it according to the actual situation
      config.headers["Authorization"] = getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {

    const data = response.data;
    if (response.status >= 200 && response.status <= 299) {
      if (data.status == 1) {
        // Message({
        //   message: data.msg_en?data.msg_en:data.msg,
        //   type: "error",
        //   duration: 2.5 * 1000
        // });
      }
      return response;
    }
  },
  error => {
    const {data} = error.response;
    if (data.code === 401) {
      console.log(data);
    } else if (data.code === 422) {
      Message({
        message: data.message,
        type: "error",
        duration: 4 * 1000
      });
    } else if (data.code === 430) {
      MessageBox.confirm(data.message, "", {
        type: "warning"
      }).then(() => {
      });
    } else if (data.code === 500) {
      Notification.error({
        title: data.message,
        dangerouslyUseHTMLString: true,
        message: `<p>ErrorNumber:${data.data.errorId}</p> We'll deal with it as soon as possible`,
        duration: 0
      });
    } else {
      Message({
        message: data.message,
        type: "error",
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
);
export default instance;



// WEBPACK FOOTER //
// ./src/axios/index.js